import waitForElementTransition from "wait-for-element-transition";
import createI18n from "./i18n";
import { ref } from "vue";


const i18n = createI18n.global;

const breakpoints = [];
const breakpointState = ref({
    cur: "",
    up: [],
    down: [],
});

["mobile", "tablet_portrait", "tablet_landscape", "desktop"].forEach((bp) => {
    let minWidth = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
            "--mdc-breakpoint-" + bp
        )
    );
    breakpoints.push({
        name: bp,
        min: minWidth,
    });
});

const calcBreakpoints = () => {
    const w = window.innerWidth;
    const bp = {
        cur: "mobile",
        up: [],
        down: [],
    };

    breakpoints.forEach((b) => {
        if (w >= b.min) {
            bp.cur = b.name;
            bp.down.push(b.name);
        }
        if (w < b.min) {
            bp.up.push(b.name);
        }
    });

    bp.up.unshift(bp.down.pop());
    breakpointState.value = bp;
};

const windowOrientation = ref({
    width: 0,
    height: 0,
    aspectRatio: 0,
});

const calcWindowOrientation = () => {
    windowOrientation.value = {
        width: window.innerWidth,
        height: window.innerHeight,
        aspectRatio: window.innerWidth / window.innerHeight,
    };
};

window.addEventListener("DOMContentLoaded",() => {
    calcBreakpoints();
    calcWindowOrientation();
});

window.addEventListener("resize", () => {
    calcBreakpoints();
    calcWindowOrientation();
});

window.cardImages = {};

const ApiUrl =
    (process.env.VUE_APP_API_DOMAIN ?? window.location.origin) +
    process.env.VUE_APP_API_URI;

/** Get fetch promise to bridge api */
const fetchApiBridge = async (query, callback) => {
    let url = new URL("CenshareBridge", ApiUrl);
    if (typeof query !== "undefined") {
        url.search = "?" + query;
    }
    fetch(url.href, {
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => res.json())
        .then(callback);
};

const isTouchDevice = () => {
    return (
        true ==
        ("ontouchstart" in window ||
            (window.DocumentTouch && document instanceof DocumentTouch))
    );
};

const dropDownClasses = () => {
    return {
        open: "open",
        close: "close",
        opened: "opened",
    };
};

const transitionClassesOpen = (opt) => {
    if (typeof opt.classes === "undefined") {
        opt.classes = {};
    }
    opt.classes = Object.assign(dropDownClasses(), opt.classes);
    opt.el.classList.remove(opt.classes.opened);
    opt.el.classList.remove(opt.classes.close);
    opt.el.classList.add(opt.classes.open);

    if (opt.dropDown) {
        let h = 0;
        if (opt.height) {
            h = opt.height;
        } else {
            for (let x = 0; x < opt.dropDown.children.length; x++) {
                h = h + opt.dropDown.children[x].offsetHeight;
            }
        }
        opt.dropDown.style.height = h + "px";

        waitForElementTransition(opt.dropDown).then(() => {
            opt.el.classList.add(opt.classes.opened);
            opt.el.classList.remove(opt.classes.close);
            opt.el.classList.remove(opt.classes.open);
            opt.dropDown.style.height = null;
            if (typeof opt.callback === "function") {
                opt.callback();
            }
        });
    } else {
        waitForElementTransition(opt.el).then(() => {
            opt.el.classList.add(opt.classes.opened);
            opt.el.classList.remove(opt.classes.open);
            if (typeof opt.callback === "function") {
                opt.callback();
            }
        });
    }
};

const transitionClassesClose = (opt) => {
    if (typeof opt.classes === "undefined") {
        opt.classes = {};
    }
    opt.classes = Object.assign(dropDownClasses(), opt.classes);
    if (opt.dropDown) {
        let h = 0;
        if (opt.height) {
            h = opt.height;
        } else {
            for (let x = 0; x < opt.dropDown.children.length; x++) {
                h = h + opt.dropDown.children[x].offsetHeight;
            }
        }
        opt.dropDown.style.height = h + "px";
    }
    opt.el.classList.remove(opt.classes.opened);
    opt.el.classList.remove(opt.classes.open);
    opt.el.classList.add(opt.classes.close);
    if (opt.dropDown) {
        window.setTimeout(() => {
            opt.dropDown.style.height = null;
            waitForElementTransition(opt.dropDown).then(() => {
                opt.el.classList.remove(opt.classes.close);
                if (typeof opt.callback === "function") {
                    opt.callback();
                }
            });
        }, 1);
    } else {
        waitForElementTransition(opt.el).then(() => {
            opt.el.classList.remove(opt.classes.close);
            if (typeof opt.callback === "function") {
                opt.callback();
            }
        });
    }
};

const transitionClassesToggle = (opt) => {
    if (typeof opt.classes === "undefined") {
        opt.classes = {};
    }
    opt.classes = Object.assign(dropDownClasses(), opt.classes);
    if (opt.el.classList.contains(opt.classes.opened)) {
        transitionClassesClose(opt);
    } else {
        transitionClassesOpen(opt);
    }
};

const isDPlusLink = (href) => {
    return href.substring(0, 26) === "https://d-plus.doehler.com" ||
        href.substring(0, 28) === "https://d-plusqa.doehler.com";
}

export {
    ApiUrl,
    breakpoints,
    breakpointState,
    windowOrientation,
    waitForElementTransition,
    isTouchDevice,
    transitionClassesOpen,
    transitionClassesClose,
    transitionClassesToggle,
    fetchApiBridge,
    i18n,
    isDPlusLink
};
